<template>
  <div class="main_">
    <div>
      <h5>第一项、付款约定</h5>
      <p>
        房屋价款具体支付方式约定为下列第 【<span class="col_red">{{
          entity.contrPayment
        }}</span
        >】款。（选一项）
      </p>
      <div>
        <van-radio-group v-model="entity.contrPayment">
          <div>
            <van-radio :name="1">
              <p>1、一次性付款</p>
                买受方于<input
                @click="showTime1 = true"
                :disabled="entity.contrPayment == 2"
                readonly
                v-model="entity.contrPayment1Date"
              />前，按本合同第二条约定房屋价款，一次性将房款缴入资金监管账户人民币（小写）<span
                class="col_red"
                >{{ obj.sumPrice }}</span
              >元。
              <van-calendar
                color="#2F72F5"
                :disabled="entity.contrPayment == 2"
                v-model="showTime1"
                @confirm="onConfirm"
                :max-date="new Date(2099, 0, 31)"
              />
              <div>
                请选择是否进行资金监管
                <input @click="showSupervise = true" :disabled="entity.contrPayment == 2" readonly v-model="supervise" />
              </div>
              <p class="text_red">
                个人二手房线上网签仅支持全款付款方式，如需办理贷款网签的，可选择去具有网签授权的房产经纪机构或银行代办点办理。
              </p>
            </van-radio>
          </div>
          <van-popup v-model="showSupervise" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="columns"
              @confirm="superviseConfirm"
              @cancel="showSupervise = false"
            />
          </van-popup>
          <!-- <van-radio :name="2">
            <p>2、贷款付款:</p>
            <div>
              买受方于<input
              :disabled="entity.contrPayment == 1"
                @click="showTime3 = true"
                readonly
                v-model="entity.contrPayment2Date1"
              />前，将首付款缴入资金监管账户，人民币（小写）<input :disabled="entity.contrPayment == 1" type="number" v-model="entity.contrPayment2Price1"> 元。
            </div>
            <div>
              买受方于<input
              :disabled="entity.contrPayment == 1"
                @click="showTime4 = true"
                readonly
                v-model="entity.contrPayment2Date2"
              />前，办理完相关银行贷款批准手续并将银行贷款缴入资金监管账户，人民币（小写）<span
                class="col_red"
                >{{ (obj.sumPrice * 100 - entity.contrPayment2Price1 * 100) / 100}}</span
              >元。
            </div>
            <div>
              请选择贷款类型
              <input @click="showLoan = true" :disabled="entity.contrPayment == 1" readonly v-model="loanType" />
            </div>
            <van-calendar
              v-model="showTime3"
              @confirm="onConfirm3"
              :max-date="new Date(2099, 0, 31)"
            />
            <van-calendar
              v-model="showTime4"
              @confirm="onConfirm4"
              :max-date="new Date(2099, 0, 31)"
            />
          </van-radio>
          <van-popup v-model="showLoan" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="loanTypeList"
              @confirm="loanConfirm"
              @cancel="showLoan = false"
            />
          </van-popup> -->
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>
        第二项、房屋交付按下列第【<span class="col_red">{{
          entity.delivery
        }}</span
        >】方式处理
      </h5>
      <div>
        <van-radio-group v-model="entity.delivery">
          <div>
            <van-radio :name="1"
              >1、出卖方应当在<input
                type="text"
                @click="showTime2 = true"
                readonly
                v-model="entity.contrDeliveryTime"
              />前，将房产交付给买受方。</van-radio
            >
            <van-calendar
              color="#2F72F5"
              v-model="showTime2"
              @confirm="onConfirm1"
              :max-date="new Date(2099, 0, 31)"
            />
          </div>
          <div>
            <van-radio :name="2"
              >2、出卖方符合领取全部房款条件后，将房产交付给买受方。</van-radio
            >
          </div>
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>第三项、关于国有土地使用权变更登记的约定</h5>
      <p>
        该土地使用权如需要缴纳土地出让金、土地收益金或土地增值税等税费的，可按下列
        第【<span class="col_red">{{
          entity.contrLandTransferringFees === "" || entity.contrLandTransferringFees === null
            ? ""
            : entity.contrLandTransferringFees + 1
        }}</span
        >】项方式处理。（选一项）
      </p>
      <div>
        <van-radio-group v-model="entity.contrLandTransferringFees">
          <div>
            <van-radio :name="0">1、出卖方承担</van-radio>
          </div>
          <div>
            <van-radio :name="1">2、买受方承担</van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>第四项、关于买卖税费的约定</h5>
      <p>
        房屋买卖过程中应当缴纳的有关税费，按下列第 【<span class="col_red">{{
          entity.contrTaxation
        }}</span
        >】 项方式处理。（选一项）
      </p>
      <div>
        <van-radio-group v-model="entity.contrTaxation">
          <div>
            <van-radio :name="1"
              >1、买、卖双方各自按国家和省、市相关规定分别缴纳。</van-radio
            >
          </div>
          <div>
            <van-radio :name="2"
              >2、买受方自愿承担本应双方缴纳的税费。</van-radio
            >
          </div>
          <div>
            <van-radio :name="3"
              >3、出卖方自愿承担本应双方缴纳的税费。</van-radio
            >
          </div>
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>第五项、违约责任</h5>
      <div>
        <div>
          1、出卖方应保证上述房产的权属清楚，若发生与出卖方该房产有关的产权纠纷或债权
          纠纷，概由卖方承担，由此给买受方造成的经济损失，由出卖方负责赔偿。
        </div>
        <div>
          2、若出卖方不能按合同规定期限交付房产或买受方不能按合同规定期限支付房款，由违约一方向对方支付<input
            type="number"
            v-model="entity.contrBreakPrice1"
          />元违约金。
        </div>
        <div>
          3、买卖双方签订合同后，如一方毁约应向对方支付<input
            v-model="entity.contrBreakPrice2"
            type="number"
          />元违约金。
        </div>
        <div class="long m_flex_box flex_vc">
          4、其他<input v-model="entity.contrBreakContent" class="flex-1" />
        </div>
      </div>
    </div>
    <div v-if="showCommission">
      <h5>第六项、关于房屋居间服务佣金的约定</h5>
      <p>
        关于房屋中介机构提供居间服务，收取佣金按 【<span class="col_red">{{ entity.commissionType !== '' ? entity.commissionType + 1 : ''}}</span
        >】 项方式处理。（选一项）
      </p>
      <div>
        <van-radio-group v-model="entity.commissionType">
          <div>
            <van-radio :name="0" :disabled="entity.commissionType === 1">1、无房屋中介机构提供居间服务，零佣金。</van-radio>
          </div>
          <div>
            <van-radio :name="1" :disabled="entity.commissionType === 0">2、由 {{param2}} 提供居间服务，佣金人民币（小写）<input :disabled="entity.commissionType === 0" v-model="entity.commission" type="number" class="flex-1" />元</van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>第{{showCommission ? '七' : '六'}}项、争议解决</h5>
      <p>
        买、卖双方在履行本合同过程中发生的争议，应协商解决；协商不成的，
        按下列第 【<span class="col_red">{{ entity.contrDispute }}</span
        >】 款方式解决。（仅选一项）
      </p>
      <div>
        <van-radio-group v-model="entity.contrDispute">
          <div>
            <van-radio :name="1">1、提交徐州仲裁委员会仲裁。</van-radio>
          </div>
          <div>
            <van-radio :name="2">2、依法向人民法院起诉。</van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>
    <div>
      <h5>第{{showCommission ? '八' : '七'}}条、补充协议</h5>
      <div>
        <textarea
          v-model="entity.contrSupplement"
          placeholder="请输入补充协议"
        ></textarea>
      </div>
    </div>
    <div v-if="entity.supervise == 1">
      <h5>第{{showCommission ? '九' : '八'}}条、资金监管信息补充</h5>
      <div>
        <div class="row m_flex_box flex_vc">
          <p>监管银行：</p>
          <div class="m_flex_box flex_vc flex-1">
            <input
              class="flex-1"
              type="text"
              v-model="trusteeBank"
              readonly
              @click="showBank = true"
            />
          </div>
          <van-popup v-model="showBank" position="bottom">
            <van-picker
              show-toolbar
              value-key="bankName"
              :columns="bankList"
              @confirm="bankConfirm"
              @cancel="showBank = false"
            />
          </van-popup>
        </div>
        <div class="row m_flex_box flex_vc">
          <p>买受人支取人：</p>
          <div class="m_flex_box flex_vc flex-1">
            <input
              v-model="buyerName"
              readonly
              @click="showUser = true"
              class="flex-1"
              type="text"
            />
          </div>
          <van-popup v-model="showUser" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="userList"
              @confirm="userConfirm"
              @cancel="showUser = false"
            />
          </van-popup>
        </div>
        <div class="row m_flex_box flex_vc">
          <p>买方银行卡号：</p>
          <input
            v-model="entity.withdrawalBankAccountDrawee"
            class="flex-1"
            type="number"
          />
        </div>
      </div>
    </div>
    <div class="btn_con m_flex_box flex_hc">
      <div @click="$router.go(-1)">上一步</div>
      <div @click="submit">下一步</div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      value: "",
      radio: "",
      showTime1: false,
      showTime2: false,
      showSupervise: false,
      showBank: false,
      showUser: false,
      supervise: "是",
      trusteeBank: "",
      buyerName: "",
      showCommission: false,
      param2: '',
      loanType: '商贷',
      showLoan: false,
      showTime3: false,
      showTime4: false,
      loanTypeList: [{
          t: "商贷",
          v: 0,
        },{
          t: "公积金",
          v: 1,
        },{
          t: "组合贷",
          v: 2,
        }],
      entity: {
        commissionType: 0,
        commission: '',
        contrPayment: "",
        contrPayment1Date: "",
        supervise: 1,
        contrDeliveryTime: "",
        delivery: "",
        contrLandTransferringFees: "",
        contrTaxation: "",
        contrBreakPrice1: "",
        contrBreakPrice2: "",
        contrBreakContent: "",
        contrDispute: "",
        contrSupplement: "",
        buyerName: "",
        trusteeBank: "",
        withdrawalBankAccountDrawee: "",
        contrPayment2Price1: '',
        contrPayment2Date1: '',
        contrPayment2Date2: '',
        loanType: 0
      },
      columns: [
        {
          t: "是",
          v: 1,
        },
        {
          t: "否",
          v: 0,
        },
      ],
      bankList: [],
      userList: [],
      obj: {},
    };
  },
  watch: {
    ['entity.contrPayment2Price1'](n, o) {
      if(n * 1 <= 0) {
        this.$toast('金额不得小于1');
        this.$set(this.entity, 'contrPayment2Price1', '');
      } else if(n > this.obj.sumPrice) {
        this.$toast('金额不得大于全款金额');
        this.$set(this.entity, 'contrPayment2Price1', o);
      }
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getAreaList (area) {
      this.$http.post('cms/onlineUser/permit/areaList.do').then(res => {
        this.showCommission = res.obj.commissionArea.includes(area)
      })
    },
    getDetail() {
      this.$http
        .post(
          "cms/contractData/reg/getOnlineContractDataOld.do",
          qs.stringify({
            contractId: this.$route.query.id,
          })
        )
        .then((res) => {
          this.bankList = res.obj.superviseBankBasicinfos;
          this.obj = res.obj;
          const userList = [
            {
              v: res.obj.purPassNo,
              t: res.obj.purchaser + "、" + res.obj.purPassNo,
            },
          ];
          for (var i = 0; i < res.obj.contractTraders.length; i++) {
            if (res.obj.contractTraders[i].traderType == 2) {
              userList.push({
                v: res.obj.contractTraders[i].idNumber,
                t:
                  res.obj.contractTraders[i].traderName +
                  "、" +
                  res.obj.contractTraders[i].idNumber,
              });
            }
          };
          this.userList = userList;
          if(res.obj.superviseFundAgreementBefore !== null) {
            this.$set(this.entity, 'buyerName', res.obj.superviseFundAgreementBefore.buyerIdCard ? res.obj.superviseFundAgreementBefore.buyerIdCard : res.obj.purPassNo);
            this.$set(this, 'buyerName', (res.obj.superviseFundAgreementBefore.buyerName ? res.obj.superviseFundAgreementBefore.buyerName : res.obj.purchaser) + '、' + (res.obj.superviseFundAgreementBefore.buyerIdCard ? res.obj.superviseFundAgreementBefore.buyerIdCard : res.obj.purPassNo));
            this.$set(this.entity, 'trusteeBank', res.obj.superviseFundAgreementBefore.trusteeBank);
            this.$set(this.entity, 'withdrawalBankAccountDrawee', res.obj.superviseFundAgreementBefore.withdrawalBankAccountDrawee);
            this.$set(this.entity, 'trusteeBank', res.obj.superviseFundAgreementBefore.withdrawalBankDrawee);
            this.bankList.forEach(item => {
              if(res.obj.superviseFundAgreementBefore.withdrawalBankDrawee == item.id) {
                this.trusteeBank = item.bankName;
              };
            });
          }
          this.getAreaList(res.obj.area);
          this.$set(this.entity, 'contrPayment', res.obj.contrPayment);
          this.$set(this.entity, 'contrPayment1Date', res.obj.contrPayment1Date);
          this.$set(this.entity, 'contrPayment2Date1', res.obj.contrPayment2Date1);
          this.$set(this.entity, 'contrPayment2Date2', res.obj.contrPayment2Date2);
          this.$set(this, 'supervise', res.obj.supervise == 0 ? '否' : '是');
          this.$set(this.entity, 'supervise', res.obj.supervise);
          this.$set(this.entity, 'delivery', res.obj.delivery);
          if(this.entity.delivery == 1) {
            this.$set(this.entity, 'contrDeliveryTime', res.obj.contrDeliveryTime);
          }
          this.$set(this.entity, 'contrLandTransferringFees', res.obj.contrLandTransferringFees);
          this.$set(this.entity, 'contrTaxation', res.obj.contrTaxation);
          this.$set(this.entity, 'contrBreakPrice1', res.obj.contrBreakPrice1);
          this.$set(this.entity, 'contrBreakPrice2', res.obj.contrBreakPrice2);
          this.$set(this.entity, 'contrBreakContent', res.obj.contrBreakContent);
          this.$set(this.entity, 'contrDispute', res.obj.contrDispute);
          this.$set(this.entity, 'contrSupplement', res.obj.contrSupplement);
          this.$set(this.entity, 'commissionType', res.obj.param1);
          this.$set(this.entity, 'commission', res.obj.commission ? res.obj.commission : '');
          this.$set(this.entity, 'contrPayment2Price1', res.obj.contrPayment2Price1 ? res.obj.contrPayment2Price1 : '');
          this.$set(this.entity, 'contrPayment2Price1', res.obj.contrPayment2Price1 ? res.obj.contrPayment2Price1 : '');
          this.$set(this.entity, 'loanType', res.obj.superviseFundAgreementBefore.loanType ? res.obj.superviseFundAgreementBefore.loanType : 0);
          if(res.obj.superviseFundAgreementBefore.loanType === '0') {
            this.$set(this, 'loanType', '商贷');
          } else if(res.obj.superviseFundAgreementBefore.loanType === '1') {
            this.$set(this, 'loanType', '公积金');
          } else if(res.obj.superviseFundAgreementBefore.loanType === '2') {
            this.$set(this, 'loanType', '混合贷');
          } else{
            this.$set(this, 'loanType', '商贷');
          }
          this.$set(this, 'param2', res.obj.param2);
        });
    },
    formatDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      }-${
        date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      } 00:00:00`;
    },
    onConfirm(date) {
      this.showTime1 = false;
      this.$set(this.entity, "contrPayment1Date", this.formatDate(date));
    },
    onConfirm1(date) {
      this.showTime2 = false;
      this.$set(this.entity, "contrDeliveryTime", this.formatDate(date));
    },
    onConfirm3(date) {
      this.showTime3 = false;
      this.$set(this.entity, "contrPayment2Date1", this.formatDate(date));
    },
    onConfirm4(date) {
      this.showTime4 = false;
      this.$set(this.entity, "contrPayment2Date2", this.formatDate(date));
    },
    superviseConfirm(data) {
      this.supervise = data.t;
      this.$set(this.entity, "supervise", data.v);
      this.showSupervise = false;
    },
    loanConfirm(data) {
      this.loanType = data.t;
      this.$set(this.entity, "loanType", data.v);
      this.showLoan = false;
    },
    bankConfirm(data) {
      this.trusteeBank = data.bankName;
      this.$set(this.entity, "trusteeBank", data.id);
      this.showBank = false;
    },
    userConfirm(data) {
      this.buyerName = data.t;
      this.$set(this.entity, "buyerName", data.v);
      this.showUser = false;
    },
    submit() {
      if (this.entity.contrPayment === '' || this.entity.contrPayment === null) {
        this.$toast('请选择付款约定')
        return;
      } else if (this.entity.contrPayment == "1" && !this.entity.contrPayment1Date) {
        //全款
        this.$toast('您选择了一次性付款，请输入付款时间');
        return;
      } else if (this.entity.contrPayment == "2" && !this.entity.contrPayment2Date1) {
        //贷款
        this.$toast('您选择了贷款付款，请输入首付付款时间');
        return;
      } else if (this.entity.contrPayment == "2" && !this.entity.contrPayment2Date2) {
        //贷款
        this.$toast('您选择了贷款付款，请输入贷款付款时间');
        return;
      } else if (this.entity.contrPayment == "2" && (!this.entity.contrPayment2Price1 || this.entity.contrPayment2Price1 === 0)) {
        //贷款
        this.$toast('您选择了贷款付款，请输入首付金额且不能为0');
        return;
      } else if (this.entity.contrPayment == "2" && !this.entity.contrPayment2Price1) {
        //贷款
        this.$toast('您选择了贷款付款，首付金额请输入数字');
        return;
      } else if (this.entity.contrPayment == "2" &&
        this.entity.contrPayment2Price1 === '' &&
        this.entity.contrPayment2Price1 >= this.entity.contractData.sumPrice) {
        //贷款
        this.$toast('您选择了贷款付款，请输入首付金额不能高于房屋总价');
        return;
      } else if (!this.entity.delivery) {
        this.$toast('请选择房屋交付时间处理方式');
        return;
      } else if (this.entity.delivery != 1 && this.entity.delivery != 2) {
        this.$toast('房屋交付时间处理方式选择错误');
        return;
      } else if (this.entity.delivery == 1 && !this.entity.contrDeliveryTime) {
        this.$toast('房屋交付时间不能为空');
        return;
      } else if (this.entity.contrLandTransferringFees === '') {
        this.$toast('请选择关于国有土地使用权变更登记的约定');
        return;
      } else if (this.entity.contrTaxation === '') {
        this.$toast('请选择关于买卖税费的约定');
        return;
      }
      // else if (contrTaxation == '2' && isNull(contrTaxation2)) {
      //     layer.alert('关于买卖税费的约定您选择了第2条，请务必选择出卖方或买受方', {
      //         icon: 2,
      //         skin: 'layer-ext-moon'
      //     })
      //
      // } else if (contrTaxation == '3' && isNull(contrTaxation3)) {
      //     layer.alert('关于买卖税费的约定您选择了第3条，请务必输入条款内容', {
      //         icon: 2,
      //         skin: 'layer-ext-moon'
      //     })
      // }
      else if (this.entity.contrBreakPrice1 === '' || this.entity.contrBreakPrice2 === '') {
        this.$toast('请输入违约金金额，没有违约金可以输入0');
        return;
      } else if (this.entity.contrBreakPrice1 === '') {
        this.$toast('违约金金额请输入数字');
        return;
      } else if (this.entity.contrBreakPrice2 === '') {
        this.$toast('违约金金额请输入数字');
        return;
      } //根据区域，判断佣金显示
      else if (
        this.showCommission &&
        this.entity.commissionType === ''
      ) {
        this.$toast('请选择房屋居间服务佣金方式');
        return;
      } else if (
        this.showCommission &&
        this.entity.commissionType == 1 && !this.entity.commission
      ) {
        this.$toast('请输入佣金数额');
        return;
      }
      else if (!this.entity.contrDispute) {
        this.$toast('请选择争议解决方式');
        return;
      }
      //  else if (
      //   ((contrPayment == "1" && supervise == 1) || contrPayment != "1") &&
      //   isNull(buyerName)
      // ) {
      //   layer.alert("买方支取人姓名为空，请选择买方支取人", {
      //     icon: 2,
      //     skin: "layer-ext-moon",
      //   });
      // } else if (
      //   ((contrPayment == "1" && supervise == 1) || contrPayment != "1") &&
      //   isNull(buyerIdCard)
      // ) {
      //   layer.alert("买方支取人证件号为空，请选择买方支取人", {
      //     icon: 2,
      //     skin: "layer-ext-moon",
      //   });
      // }
      else if (((this.entity.contrPayment == "1" && this.entity.supervise == 1) || this.entity.contrPayment != "1") && !this.entity.trusteeBank) {
        this.$toast('请选择资金监管银行');
        return;
      } else if (((this.entity.contrPayment == "1" && this.entity.supervise == 1) || this.entity.contrPayment != "1") && !this.entity.withdrawalBankAccountDrawee){
        this.$toast('请输入买方支取人银行卡号')
        return;
      }
      this.$http({
        url: 'cms/contractData/reg/saveOnlineContractInfo.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: Object.assign({}, this.entity, {
          id: this.$route.query.id,
          superviseFundAgreementBefore:{
            buyerName: this.buyerName.split('、')[0],
            buyerIdCard: this.buyerName.split('、')[1],
            trusteeBank: this.entity.trusteeBank,
            loanType: this.entity.contrPayment == 2 ? this.entity.loanType : '',
            withdrawalBankAccountDrawee: this.entity.withdrawalBankAccountDrawee,
          }
        })
      }).then(res => {
        this.$toast(res.msg);
        if(res.success) {
          this.$router.push({
            path: '/showContract',
            query: {
              id: this.$route.query.id
            }
          })
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.col_red {
  color: red;
  font-weight: bolder;
}
.text_red {
  color: red;
}
.main_ {
  padding: 0.3rem;
  font-size: 0.28rem;
  line-height: 0.6rem;
  > div {
    margin-bottom: 0.6rem;
    h5 {
      font-size: 0.32rem;
      font-weight: 800;
      margin-bottom: 0.2rem;
    }
    p {
      margin-bottom: 0.2rem;
    }
    div {
      margin-bottom: 0.2rem;
    }
    input {
      border: 1px solid #dcdcdc;
      padding: 0 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
    }
    /deep/ .van-radio__icon {
      line-height: 0.6rem;
      height: auto;
    }
    /deep/ .van-radio__label {
      line-height: 0.6rem;
    }
    .long {
      /deep/ .van-radio__label {
        width: 100%;
        display: flex;
      }
    }
    .row {
      p {
        width: 2.1rem;
      }
    }
    /deep/ .van-popup {
      margin-bottom: 0;
    }
  }
  textarea {
    border: 1px solid #dcdcdc;
    width: 100%;
    display: block;
    height: 3rem;
    box-sizing: border-box;
    padding: 0.2rem;
  }
}
.btn_con {
  div {
    line-height: 0.8rem;
    width: 2.8rem;
    border-radius: 0.06rem;
    text-align: center;
    box-sizing: border-box;
    margin: 0 0.2rem;
    &:first-child {
      border: 1px solid #999;
      color: #999;
    }
    &:last-child {
      background-color: #2f72f5;
      color: #fff;
    }
  }
}
/deep/
.van-radio{
  align-items: flex-start;
  .van-radio__icon{
    margin-top: 0.1rem;
  }
}
</style>